export class SettingModel{
  id:number;
  wmsLink:string;
  mapCacheId:string;
  srid:number;
  mapCacheName:string;
  server:string;
  port:string;
  email:string;
  password:string;
  ssl:boolean;
  mapAttributation:string;
  domainName:string;
}
